<template>
  <div class="box">
    <div class="box-header">
      <div class="col-12 col-md-12 col-sm-12 col-xs-12" style="border-top: 1px dashed #d2d6de; border-bottom: 1px dashed #d2d6de; margin-top: 10px;">
        <div class="row">
          <div class="form-group col-6 col-md-1 div-form-filtro">
            <select v-model="filtro.uf" style="width: auto;" class="form-control form-filtro" v-bind:class="{ 'box-input-required': errors.uf }">
              <option value="" selected>UF</option>
              <option value="AC">AC</option>
              <option value="AL">AL</option>
              <option value="AM">AM</option>
              <option value="AP">AP</option>
              <option value="BA">BA</option>
              <option value="CE">CE</option>
              <option value="DF">DF</option>
              <option value="ES">ES</option>
              <option value="GO">GO</option>
              <option value="MA">MA</option>
              <option value="MG">MG</option>
              <option value="MS">MS</option>
              <option value="MT">MT</option>
              <option value="PA">PA</option>
              <option value="PB">PB</option>
              <option value="PE">PE</option>
              <option value="PI">PI</option>
              <option value="PR">PR</option>
              <option value="RJ">RJ</option>
              <option value="RN">RN</option>
              <option value="RO">RO</option>
              <option value="RR">RR</option>
              <option value="RS">RS</option>
              <option value="SC">SC</option>
              <option value="SE">SE</option>
              <option value="SP">SP</option>
              <option value="TO">TO</option>
            </select>
          </div>
          <div class="form-group col-6 col-md-4 div-form-filtro">
            <select v-model="filtro.cd_status_motorista" style="width: auto;" class="form-control form-filtro" v-bind:class="{ 'box-input-required': errors.cd_status_motorista }">
              <option value="" selected>Status Motorista</option>
              <option value="1">Ativo</option>
              <option value="2">Reprovado</option>
              <option value="3">Aguardando Validação</option>
              <option value="4">Agendamento Solicitado</option>
              <option value="5">Aguardando Agendamento</option>
              <option value="6">Aguardando Ponto de Apoio</option>
              <option value="7">Aguardando Equipamento</option>
              <option value="8">gendamento Realizado</option>
              <option value="9">Excluído</option>
              <option value="10">Outras Praças</option>
              <option value="11">Pendente</option>
              <option value="12">Furto, Roubo ou Avaria</option>
              <option value="13">Aguardando Pré-análise</option>
              <option value="14">Cadastro não Finalizado - Pré-aprovado</option>
            </select>
          </div>
          <div class="form-group col-6 col-md-3 div-form-filtro">
            <button type="button" class="btn btn-sm btn-success btn-novo" @click="enviar()">Enviar</button>
          </div>
        </div>
      </div>
    </div>
		<div v-show="errorMessage != ''" class="alert alert-danger">{{ errorMessage }}</div>
		<div v-show="successMessage != ''" class="alert alert-success">{{ successMessage }}</div>
  </div>
</template>

<script>
import ActionsLogin from '../../actions/LoginActions'
import MensagemActions from '../../actions/MensagemActions'

export default {
  name: 'envio-manual',
  components: {
  },
  data () {
    return {
      errors: {},
      errorMessage: '',
      successMessage: '',
      filtro: {
        uf: '',
        cd_status_motorista: ''
      }
    }
  },
  mounted () {
    this.$parent.$parent.$data.description = 'Envio Manual'

    this.$events.$on('filter-set', eventData => this.onFilterSet(eventData))
  },
  computed: {
    httpOptions () {
      return { headers: { 'Authorization': 'Bearer ' + ActionsLogin.getToken() } }
    }
  },
  methods: {
    onLoading () {
      this.$parent.$parent.$data.showModalLoader = true
    },
    onLoaded () {
      this.$parent.$parent.$data.showModalLoader = false
    },
    enviar () {
      let hasError = false

      this.errors = {}
      this.successMessage = ''
      this.errorMessage = ''

      if (!this.filtro.uf) {
        this.errors.uf = 'Este campo deve ser preenchido.'
        hasError = true
      }
      if (!this.filtro.cd_status_motorista) {
        this.errors.cd_status_motorista = 'Este campo deve ser preenchido.'
        hasError = true
      }

      if (!hasError) {
        this.onLoaded()

        MensagemActions.enviar(this.filtro.cd_status_motorista, this.filtro.uf)
          .then(response => {
            this.onLoaded()

            if (response.data.success) {
              this.successMessage = 'Envio disparado com sucesso.'
            } else {
              this.errorMessage = 'Ocorreu um erro ao efetuar o envio.'
            }
          })
          .catch((error) => {
            console.log(error.message)
            this.errorMessage = 'Ocorreu um erro ao efetuar o envio.'
            this.onLoaded()
          })
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/pages/mensagens/EnvioManual.vue